<i18n>
{
  "en":{
    "title": "System",
    "terminal": {
      "serialnumber": "Serial number",
      "hardware": "Part number",
      "location": "Location",
      "credit": "System credits (last 5)",
      "config": "System configs (last 5)"
    },
    "history": {
      "days": "added {amount} days",
      "credit": "added {amount} credits"
    },
    "buttons": {
      "download": {
        "license": "Download latest config file",
        "credit": "Download latest time/pulse file"
      }
    }
  },
  "da":{
    "title": "System",
    "terminal": {
      "serialnumber": "Serienummer",
      "hardware": "Partnummer",
      "location": "Lokation",
      "credit": "Kredithistorik (sidste 5)",
      "config": "Konfigurationshistorik (sidste 5)"
    },
    "history": {
      "days": "tilføjede {amount} dage",
      "credit": "tilføjede {amount} kredit"
    },
    "buttons": {
      "download": {
        "license": "Download seneste konfigurationsfil",
        "credit": "Download seneste tids-/pulsfil"
      }
    }
  }
}
</i18n>

<template>
  <b-row class="mb-2">
    <b-col>
      <b-row>
        <div id="system-header">
          <h1 class="">{{ $t('title') }}</h1>
        </div>
      </b-row>

      <b-row v-if="compact">
        <b-col md="4" v-if="system.SystemPartNumber !== ''">
          <p>
            {{$t('terminal.hardware')}}: {{system.SystemPartNumber}} ({{$t(`systemtypes.${system.SystemPartNumber}`)}})
          </p>
        </b-col>
        
        <b-col md="4">
          <p>
            {{ $t('terminal.serialnumber') }}: {{system.SerialNumber}}
          </p>
        </b-col>

        <b-col md="4" v-if="system.Location !== ''">
          <p>
            {{ $t('terminal.location') }}: {{system.Location}}
          </p>
        </b-col>
      </b-row>

      <b-row v-if="verbose">
        <b-col md="5">
            <ul>
              <li>{{ $t('terminal.serialnumber') }}: {{system.SerialNumber}}</li>
            </ul>

            <b-button v-if="files.credit !== undefined  && type ==='credit'" variant="outline-primary" class="file-button" v-on:click="downloadCreditFile()">
              {{$t('buttons.download.credit')}}
            </b-button>
            
            <b-button v-if="files.license !== undefined  && type ==='config'" variant="outline-primary" class="file-button" v-on:click="downloadConfigFile()">
              {{$t('buttons.download.license')}}
            </b-button>

        </b-col>

        <b-col md="7">
            
          <ul>
            <li v-if="system.SystemPartNumber !== ''">
              {{$t('terminal.hardware')}}: {{system.SystemPartNumber}} ({{$t(`systemtypes.${system.SystemPartNumber}`)}})
            </li>
            <li v-if="system.Location !== ''">{{ $t('terminal.location') }}: {{system.Location}}</li>
           
            <li v-if="compact == false && type === 'credit'">{{ $t('terminal.credit') }}
                <ul>
                <li v-for="file in history.credit" v-bind:key="file.FileID">
                    {{parseDate(file.Created)}}: {{file.User.CompanyName}}  {{ file.CreditFile.Unit === 'CREDIT' ?  $t('history.credit', {amount: file.CreditFile.Amount}) : $t('history.days', {amount: file.CreditFile.Amount}) }}
                </li>
                </ul>
            </li>

           <li v-if="compact == false && type === 'config'">{{ $t('terminal.config') }}
                <ul>
                <li v-for="file in history.license" v-bind:key="file.FileID">
                  {{parseDate(file.Created)}}: {{file.User.CompanyName}}
                </li>
                </ul>
            </li>

          </ul>

        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>

import moment from 'moment'
import FileSaver from 'file-saver'

import elg from '../../api/elg.gateway.js'

export default {
  components: {
    
  },
  props: ['system', 'compact', 'type'],
  data() {
    return {
      files: {
        license: undefined,
        credit: undefined
      },
      history:{
        license: [],
        credit: []
      }
    };
  },
  computed:{
    verbose(){
      return !this.compact
    }
  },

  methods: {
    parseDate (date){
      return moment(date).format('YYYY-MM-DD')
    },
    downloadCreditFile(){
      elg()
      .get('/api/v1/files/' + this.files.credit.FileID)
      .then((response) => {
        FileSaver.saveAs(new Blob([response.data]), this.files.credit.Filename);
      });
    },
    downloadConfigFile(){
      elg()
      .get('/api/v1/files/' + this.files.license.FileID)
      .then((response) => {
        FileSaver.saveAs(new Blob([response.data]), this.files.license.Filename);
      });
    }
  },

  mounted() {
    elg()
    .get(`/api/v1/system/${this.$route.params.logosid}/files?Latest=True`)
    .then( res => {
      var license = _.find(res.data, function (o){
        return o.FileTypeID === 100;
      });

      var credit = _.find(res.data, function (o){
        return o.FileTypeID === 200;
      });

      if(license !== undefined){
        this.files.license = license;
      }

      if(credit !== undefined){
        this.files.credit = credit;
      }

      if(this.compact === false && this.type === 'credit'){
        elg()      
          .get(`/api/v1/system/${this.$route.params.logosid}/files?FileType=Credit&Offset=0&Limit=5`)
          .then( res =>{
            this.history.credit = res.data;
          });
      }else if(this.compact === false && this.type === 'config'){
        elg()      
          .get(`/api/v1/system/${this.$route.params.logosid}/files?FileType=License&Offset=0&Limit=5`)
          .then( res =>{
            this.history.license = res.data;
          });
      }
    });
  }
};
</script>

<style scoped>

.file-button{
  margin-left: 40px;
  margin-bottom: 15px;
  min-width: 175px;
}

p {
  font-size: 18px;
}

</style>


// WEBPACK FOOTER //
// WebApp/components/subcomponent/SystemDetails.vue